import api from './api'

export default {
  async getAll() {
    const { data } = await api.get('/admin/cities')
    return data
  },

  async getById(id) {
    const { data } = await api.get(`/admin/cities/${id}`)
    return data
  },

  async create(cityData) {
    const { data } = await api.post('/admin/cities', cityData)
    return data
  },

  async update(id, cityData) {
    const { data } = await api.put(`/admin/cities/${id}`, cityData)
    return data
  },

  async delete(id) {
    const { data } = await api.delete(`/admin/cities/${id}`)
    return data
  }
}

